import request from '@webtrader/core/request';

export enum EUserPreferenceCategory {
  ONE_CLICK_TRADING = 'ONE_CLICK_TRADING',
  LINE_DRAWING = 'LINE_DRAWING',
  SWAP_UNITS = 'SWAP_UNITS',
  PRE_TRADE_PIN = 'PRE_TRADE_PIN',
  DEALER = 'DEALER',
  CANDLESTICK = 'CANDLESTICK'
}

export enum EUserPreferenceType {
  OCT_ENABLE = 'OCT_ENABLE',
  LINE_DRAWING = 'LINE_DRAWING',
  SWAP_UNITS = 'SWAP_UNITS',
  PTP_ENABLE = 'PTP_ENABLE',
  DEALER_FILTER_TYPES = 'DEALER_FILTER_TYPES',
  CANDLESTICK_COLOR = 'CANDLESTICK_COLOR'
}

export interface IGetUserPreferenceParam {
  category: EUserPreferenceCategory;
  type: EUserPreferenceType;
  symbol?: string;
}

export interface IGetUserPreferenceResponse {
  category: EUserPreferenceCategory;
  type: EUserPreferenceType;
  value: string;
  symbol?: string;
}

export interface IUpdateUserPreferenceParam {
  category: EUserPreferenceCategory;
  type: EUserPreferenceType;
  value: string;
}

export default {
  getUserPreference: (params?: IGetUserPreferenceParam, signal?: AbortSignal) =>
    request.get<IGetUserPreferenceResponse[]>('/api/user/v1/preference', { params, signal }),
  updateUserPreference: (params: IUpdateUserPreferenceParam, signal?: AbortSignal) =>
    request.patch<boolean>('/api/user/v1/preference', params, { signal })
};
